import React from "react";
import Modal from "components/modal";
import { MdSchool, MdCalendarToday, MdPerson, MdSupervisorAccount, MdBook, MdLocationOn, MdDescription, MdFileDownload, MdEdit, MdDelete } from "react-icons/md";

const MemoireDetailModal = ({ isOpen, onClose, memoire, onEdit, onDelete, onDownload }) => {
  // Formatage de la date
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);
    } catch (error) {
      return dateString;
    }
  };

  if (!memoire) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} width="lg">
      <div>
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-1">
            {memoire.memoire_theme}
          </h2>
          <div className="flex items-center text-sm text-gray-600">
            <MdSchool className="mr-1 h-4 w-4" />
            <span>{memoire.memoire_annee}</span>
          </div>
          <div className="h-1 w-16 bg-indigo-600 mt-4 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div className="space-y-4">
            <div className="flex items-start">
              <MdPerson className="h-5 w-5 text-indigo-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Étudiant</h3>
                <p className="text-base text-gray-900">{memoire.memoire_etudiant}</p>
              </div>
            </div>

            <div className="flex items-start">
              <MdSupervisorAccount className="h-5 w-5 text-indigo-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Encadrant</h3>
                <p className="text-base text-gray-900">{memoire.memoire_encadrant}</p>
              </div>
            </div>

            <div className="flex items-start">
              <MdCalendarToday className="h-5 w-5 text-indigo-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Date de soutenance</h3>
                <p className="text-base text-gray-900">{formatDate(memoire.memoire_date)}</p>
              </div>
            </div>

            <div className="flex items-start">
              <MdBook className="h-5 w-5 text-indigo-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Filière</h3>
                <p className="text-base text-gray-900">{memoire.memoire_filiere}</p>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <div className="flex items-start">
              <MdLocationOn className="h-5 w-5 text-indigo-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Établissement</h3>
                <p className="text-base text-gray-900">{memoire.memoire_etablissement}</p>
              </div>
            </div>

            <div className="flex items-start">
              <MdFileDownload className="h-5 w-5 text-indigo-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Fichier</h3>
                <button 
                  onClick={() => onDownload(memoire)}
                  className="text-base text-indigo-600 hover:text-indigo-800 font-medium underline"
                >
                  Télécharger le PDF
                </button>
              </div>
            </div>

            {memoire.memoire_description && (
              <div className="flex items-start">
                <MdDescription className="h-5 w-5 text-indigo-600 mt-0.5 mr-3 flex-shrink-0" />
                <div>
                  <h3 className="text-sm font-medium text-gray-700">Description</h3>
                  <p className="text-base text-gray-900">
                    {memoire.memoire_description}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="mt-8 flex justify-end gap-3">
          <button
            type="button"
            onClick={onEdit}
            className="inline-flex items-center px-4 py-2 rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 border border-transparent"
          >
            <MdEdit className="mr-2 h-4 w-4" />
            Modifier
          </button>
          <button
            type="button"
            onClick={onDelete}
            className="inline-flex items-center px-4 py-2 rounded-md text-red-700 bg-red-100 hover:bg-red-200 border border-transparent"
          >
            <MdDelete className="mr-2 h-4 w-4" />
            Supprimer
          </button>
          <button
            type="button"
            className="px-4 py-2 rounded-md text-gray-600 border border-gray-300 bg-white hover:bg-gray-50 transition-colors"
            onClick={onClose}
          >
            Fermer
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MemoireDetailModal;